
/* injects from baggage-loader */

// $uibModal

'use strict';

import { Rect } from '../models/Rect';
import { Circle } from '../models/Circle';
import { Triangle } from '../models/Triangle';

import { FormTypes } from '../../index.const';

import _ from 'lodash';

const FORM_CONTAINER_WIDTH = (240 - 100);
const FORM_CONTAINER_HEIGHT = (426 - 80);

export default function (app) {
  app
    .factory('$Forms', Forms);

  function Forms() {
    'ngInject';

    let self = {};

    self.create = function(type, size, color, total){
        let forms = [];

        for (let i=1; i <= total; i++){
            switch (type) {
                case FormTypes.rect:
                    forms.push( new Rect(self.randomX(), self.randomY(), self.randomAngle(), size, color) );
                    break;
                case FormTypes.circle:
                    forms.push( new Circle(self.randomX(), self.randomY(), self.randomAngle(), size, color) );                    
                    break;
                case FormTypes.triangle:
                    forms.push( new Triangle(self.randomX(), self.randomY(), self.randomAngle(), size, color) );
                    break;            
                default:
                    break;
            }
        }

        return _.shuffle(forms);
    }

    self.randomX = function(){
        return _.random(8, FORM_CONTAINER_WIDTH)
    }

    self.randomY = function(){
        return _.random(64, FORM_CONTAINER_HEIGHT)
    }

    self.randomAngle = function(){
        return _.random(-360, 360)
    }

    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/forms.factory.js